import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'mat-version-check-dialog',
    templateUrl: './version-check-dialog.component.html',
    styleUrls: [ './version-check-dialog.component.scss' ],
})
export class VersionCheckDialogComponent {

    constructor(private myMatDialogRef: MatDialogRef<VersionCheckDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public blockTimeMinutes: number) {
        //
    }

    public ignore(): void {
        this.myMatDialogRef.close('ignore');
    }

    public reload(): void {
        this.myMatDialogRef.close('reload');
    }

}
